module.exports = __webpack_public_path__ + "img/Yotta-blueprint.27f5b5.png";